"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMarketingFreeSettings = void 0;

var getMarketingFreeSettings = function getMarketingFreeSettings(state) {
  return state.modules.marketing['collected-forms'].entities.marketingFreeSettings;
};

exports.getMarketingFreeSettings = getMarketingFreeSettings;